import * as I18n from 'i18n-js';
import { CoreBumpRecommendationListingCard } from '../../schemas/rql';
import { shouldGetBuyBoxRecommendation, fixPrecision } from './bump_helpers';

export function recommendationText(
  recommendationAmount: number,
  listing: CoreBumpRecommendationListingCard.Fragment,
) {
  if (shouldGetBuyBoxRecommendation(listing)) {
    return I18n.t('discovery.bumpModalV2.buyBoxRecommendation', {
      tagOpen: '<span class="weight-bold">',
      tagClose: '</span>',
      bumpPercent: fixPrecision(recommendationAmount),
    });
  }

  return I18n.t('discovery.bumpModalV2.percentileRecommendation', {
    bumpPercent: fixPrecision(recommendationAmount),
    percentile: 85,
    tagOpen: '<span class="weight-bold">',
    tagClose: '</span>',
  });
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/button_display_recommendations.tsx